import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import useDate from "../../../hooks/useDate";
import TodaysEvent from "../TodaysEvent";
import classes from "../../pages/user/dashboard/dashboard.module.css";
import { formatDate } from "../../../utilities/helper";
import useEvents from "../../../hooks/useEvents";

const Dashboardevents = () => {
   const date = useDate();
   const { getEvents } = useEvents();

   const [calendarDate, setCalendarDate] = useState(date);

   useEffect(() => {
      const formatedDate = formatDate(calendarDate);
      getEvents({
         pageNo: 0,
         pageSize: 3,
         search: `eventDate:${formatedDate}`,
      });
   }, [calendarDate]);

   const calendarEffect = (event) => {
      setCalendarDate(event);
   };
   return (
      <>
         <Calendar value={calendarDate} onChange={calendarEffect} />
         <h4>Todays Event</h4>
         <div className={classes.todayEvent}>
            <TodaysEvent />
         </div>
      </>
   );
};

export default Dashboardevents;
